import {
  getFeedMymesAPI,
  GETFeedMymesByCategory,
  GETFeedSearch,
  getFeedSearchAPI,
  GETFeedSearchParams,
  getPopularMymesAPI
} from '@myme/api';
import {
  Pagination,
  sendRequest,
  transformArrayToSearchParams,
  transformPaginationToSearchParams,
  UUID
} from '@myme/utils';

/* **** GET **** /feed */
export const getFeedMymesByCategory = async (categoryId: UUID, pagination: Pagination) =>
  sendRequest<GETFeedMymesByCategory, null>(getFeedMymesAPI, {
    queryStringParams: [...transformPaginationToSearchParams(pagination), { key: 'categoryId', value: categoryId }]
  });

// TODO In secound version of project delete getFeedMymesByCategoryMobile and use getFeedMymesByCategory on Mobile
/* **** GET **** /feed */
export const getFeedMymesByCategoryMobile = async (categoryId: UUID, pagination: Pagination, isFree: boolean) =>
  sendRequest<GETFeedMymesByCategory, null>(getFeedMymesAPI, {
    queryStringParams: [
      ...transformPaginationToSearchParams(pagination),
      { key: 'categoryId', value: categoryId },
      { key: 'isFree', value: isFree }
    ]
  });

/* **** GET **** /feed/search */
export const searchFeedMymes = async (params: GETFeedSearchParams, pagination: Pagination) =>
  sendRequest<GETFeedSearch, null>(getFeedSearchAPI, {
    queryStringParams: [
      ...transformPaginationToSearchParams(pagination),
      { key: 'searchQuery', value: params.searchQuery },
      ...transformArrayToSearchParams('categoryIds', params.categoryIds),
      ...transformArrayToSearchParams('types', params.types)
    ]
  });

// TODO In secound version of project delete searchFeedMymesMobile and use searchFeedMymes on Mobile
/* **** GET **** /feed/search */
export const searchFeedMymesMobile = async (params: GETFeedSearchParams, pagination: Pagination, isFree: boolean) =>
  sendRequest<GETFeedSearch, null>(getFeedSearchAPI, {
    queryStringParams: [
      ...transformPaginationToSearchParams(pagination),
      { key: 'searchQuery', value: params.searchQuery },
      ...transformArrayToSearchParams('categoryIds', params.categoryIds),
      ...transformArrayToSearchParams('types', params.types),
      { key: 'isFree', value: isFree }
    ]
  });

/* **** GET **** /feed/popular */
export const getPopularMymes = async (pagination: Pagination) =>
  sendRequest<GETFeedMymesByCategory, null>(getPopularMymesAPI, {
    queryStringParams: transformPaginationToSearchParams(pagination)
  });

// TODO In secound version of project delete getPopularMymesMobile and use getPopularMymes on Mobile
/* **** GET **** /feed/popular */
export const getPopularMymesMobile = async (pagination: Pagination, isFree: boolean) =>
  sendRequest<GETFeedMymesByCategory, null>(getPopularMymesAPI, {
    queryStringParams: [...transformPaginationToSearchParams(pagination), { key: 'isFree', value: isFree }]
  });
